import { render, staticRenderFns } from "./EditGoods.vue?vue&type=template&id=f042ae48&"
import script from "./EditGoods.vue?vue&type=script&lang=js&"
export * from "./EditGoods.vue?vue&type=script&lang=js&"
import style0 from "./EditGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports